<template>
<div>
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col offset-5 mt-4 mb-4">
          <h5>Welcome <strong>{{username}}</strong></h5>
        </div>
      </div>
      <b-form-group label-cols="5" label="Password" label-for="password" label-align-sm="right">
        <b-form-input id="password" v-model="password" type="password" :state="passwordState" aria-describedby="password-input-feedback"></b-form-input>
        <b-form-invalid-feedback id="password-input-feedback" class="text-right">{{passwordError}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="5" label="Confirm password" label-for="confirm-password" label-align-sm="right">
        <b-form-input id="confirm-password" v-model="confirmPassword" type="password" :state="confirmPasswordState" @keydown.native.enter.prevent="changePassword" aria-describedby="password-confirm-input-feedback"></b-form-input>
        <b-form-invalid-feedback id="password-confirm-input-feedback" class="text-right">{{confirmPasswordError}}</b-form-invalid-feedback>
      </b-form-group>
      <div class="row">
        <div class="offset-5 col mt-3">
          <b-alert v-model="showChangedAlert" variant="success" dismissible>
            Password updated
          </b-alert>
        </div>
      </div>
      <div class="row">
        <div class="offset-5 col">
          <b-button variant="primary" class="mb-4" @click="changePassword">Change password</b-button>
          <p><a href="#" @click.prevent="logout">Logout</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import client from 'api-client';

export default {
  name: 'ChangePassword',
  data() {
    return {
      password: null,
      confirmPassword: null,
      passwordError: null,
      confirmPasswordError: null,
      showChangedAlert: false
    }
  },
  computed: {
    passwordState() { return this.passwordError ? false : null; },
    confirmPasswordState() { return this.confirmPasswordError ? false : null; },
    username() { return this.$store.state.login.username }
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      this.passwordError = null;
      this.confirmPasswordError = null;
      this.showChangedAlert = null;
    },
    changePassword() {
      this.reset();
      if (this.password == null) {
        this.passwordError = "Field is required";
      }
      if (this.confirmPassword == null) {
        this.confirmPasswordError = "Field is required";
      }
      if (this.password && this.confirmPassword) {
        client.changePassword(this.password, this.confirmPassword)
          .then(() => {
            this.password = null;
            this.confirmPassword = null;
            this.showChangedAlert = true;
          })
          .catch(res => {
            this.confirmPasswordError = res.message;
          });
      }
    },
    logout() {
      client.logout()
        .then(() => {
          this.$store.commit('setLoggedIn', false);
          this.$router.push("/");
        });
    }
  }
}
</script>
